/**
 * API Configuration Utilities
 * Shared utilities for API endpoint configuration across theme files
 */

// Development mode toggle - set to true to use local dev server
const USE_DEV_SERVER = false; // Change to false for production

// Development configuration
const DEV_SHOP_URL = "https://your-ngrok-tunnel-url.ngrok-free.app"; // Populate this with your tunnel URL
const DEV_API_PATH = "api";
const DEV_NGROK_SKIP_BROWSER_WARNING = false; // Change to false for production

// Production configuration
const PROD_API_PATH = "apps/lambda";

/**
 * Gets API configuration - handles both production and development environments
 * @returns {{shopUrl: string, apiPath: string}} Configuration object with shop URL and API path
 */
function getApiConfig() {
  // Get shop URL from body attribute or window global
  let shopUrl = (typeof $ !== 'undefined' && $("body").attr("data-shop-url")?.trim()) ||
    (typeof document !== 'undefined' && document.querySelector("body")?.getAttribute("data-shop-url")?.trim()) ||
    window.shopUrl ||
    '';

  let apiPath = PROD_API_PATH;

  // Local dev override
  if (USE_DEV_SERVER) {
    shopUrl = DEV_SHOP_URL;
    apiPath = DEV_API_PATH;
  }

  return { shopUrl, apiPath };
}

/**
 * Builds full API URL for a given endpoint
 * @param {string} endpoint - API endpoint path (e.g., "/webtheme/theme/patient/update/marketingConsent")
 * @returns {string} Full API URL
 */
function getApiUrl(endpoint) {
  const { shopUrl, apiPath } = getApiConfig();
  // Ensure endpoint starts with /
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${shopUrl}/${apiPath}${cleanEndpoint}`;
}

/**
 * Gets API options and appends ngrok-skip-browser-warning header if DEV_NGROK_SKIP_BROWSER_WARNING is true
 * @param {Object} options - Additional options to pass to the API
 * @returns {Object} API options
 */
function getApiOptions(options = {}) {
  if (DEV_NGROK_SKIP_BROWSER_WARNING) {
    return {
      ...options,
      headers: {
        'ngrok-skip-browser-warning': 'true',
        ...options.headers
      }
    };
  }
  return options;
}

/**
 * Gets API fetch arguments
 * @param {string} endpoint - API endpoint path (e.g., "/webtheme/theme/patient/update/marketingConsent")
 * @param {Object} options - Additional options to pass to the API
 * @returns {Object} API fetch arguments
 */
function getApiFetchArgs(endpoint, options = {}) {
  const url = getApiUrl(endpoint);
  const appendedOptions = getApiOptions(options);
  return { url, options: appendedOptions };
}

// Expose globally for use across theme files
if (typeof window !== 'undefined') {
  window.getApiConfig = getApiConfig;
  window.getApiUrl = getApiUrl;
  window.getApiOptions = getApiOptions;
  window.getApiFetchArgs = getApiFetchArgs;
}
